import React, { useRef, useEffect } from 'react';
import SearchBar from './SearchBar';

interface SearchBarContainerProps {
  isSearchExpanded: boolean;
  setIsSearchExpanded: (value: boolean) => void;
  isDesktop: boolean;
}

const SearchBarContainer: React.FC<SearchBarContainerProps> = ({ 
  isSearchExpanded, 
  setIsSearchExpanded, 
  isDesktop 
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isSearchExpanded && 
        containerRef.current && 
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsSearchExpanded(false);
      }
    };

    if (isSearchExpanded) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSearchExpanded, setIsSearchExpanded]);

  return (
    <div 
      ref={containerRef} 
      className="relative z-20 ml-auto"
    >
      <SearchBar 
        isSearchExpanded={isSearchExpanded} 
        setIsSearchExpanded={setIsSearchExpanded}
        isDesktop={isDesktop}
      />
    </div>
  );
};

export default SearchBarContainer;